

export const makeSensorDataBySiteId = (sensors) => sensors.reduce((sensorDataBySiteId, sensorItem) => {
    const siteId = sensorItem?.site;
    const sensor_count = sensorItem?.sensor_count;
    const cml_count = sensorItem?.cml_count;

    sensorDataBySiteId[siteId] = {
        siteId,
        sensor_count,
        cml_count
    };
    return sensorDataBySiteId;
}, {});



export const transformDataForChart = (sensorData) => {
    const siteIds = Object.keys(sensorData);
    const sensorCounts = siteIds.map(siteId => sensorData[siteId].sensor_count);
    const cmlCounts = siteIds.map(siteId => sensorData[siteId]?.cml_count || 0);

    return {
        siteIds,
        sensorCounts,
        cmlCounts
    };
};